const itemsToText = (items, maxLength = 160, currentLength = 0) => {
  let text = "";
  items.some(item => {
    if (item.type === "text") {
      text = text.concat(item.text);
    } else if (item.items) {
      text = text.concat(itemsToText(item.items, maxLength, text.length));
    }
    if (currentLength + text.length >= 160) {
      return text;
    }
    return false;
  });
  return text;
};

const contentToText = (content, maxLength = 160) => itemsToText(content, 160).slice(0, maxLength);

export { contentToText as default };
